import posthog from 'posthog-js';

export default {
  install(Vue) {
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$posthog = posthog;
  },
};
